import { Products } from 'enums';

const useMapProductNames = () => {
  const mapProductName = (product: string) => {
    switch (product) {
      case Products.SAIA_RECRUITING:
        return 'SAIA Recruiting';
      case Products.SAIA_SALES:
        return 'SAIA Sales';
      case Products.MOTIVE:
        return 'MotivE';
      case Products.LEAD:
        return 'LEaD';
      default:
        return product;
    }
  };

  return mapProductName;
};

export default useMapProductNames;
